import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { classNames } from "../../utils/string";
import {
  EllipsisHorizontalIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

export default function DeviceMenu({
  menu,
  onEdit,
  onDelete,
}: {
  menu: {
    name: string;
    action: any;
  }[];
  onEdit?: () => void;
  onDelete?: () => void;
}) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="flex items-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-300 hover:text-gray-600 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100 dark:focus:ring-offset-gray-800 p-2">
          <span className="sr-only">Open options</span>
          <EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" />
        </MenuButton>
      </div>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 dark:ring-gray-700 dark:shadow-[0_5px_15px_rgba(0,0,0,0.3)] focus:outline-none">
          <div className="py-1">
            {onEdit && (
              <MenuItem>
                {({ focus }) => (
                  <button
                    onClick={onEdit}
                    className={classNames(
                      focus
                        ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white"
                        : "text-gray-700 dark:text-gray-300",
                      "flex items-center gap-2 w-full px-4 py-2 text-sm cursor-pointer",
                    )}
                  >
                    <PencilIcon className="h-4 w-4" />
                    Edit Device
                  </button>
                )}
              </MenuItem>
            )}
            {onDelete && (
              <MenuItem>
                {({ focus }) => (
                  <button
                    onClick={onDelete}
                    className={classNames(
                      focus
                        ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white"
                        : "text-gray-700 dark:text-gray-300",
                      "flex items-center gap-2 w-full px-4 py-2 text-sm cursor-pointer",
                    )}
                  >
                    <TrashIcon className="h-4 w-4" />
                    Delete Device
                  </button>
                )}
              </MenuItem>
            )}
            {/* Keep the original menu items if they exist */}
            {menu.map((menuItems, index) => (
              <MenuItem key={index}>
                {({ focus }) => (
                  <button
                    onClick={menuItems.action}
                    className={classNames(
                      focus
                        ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white"
                        : "text-gray-700 dark:text-gray-300",
                      "flex items-center gap-2 w-full px-4 py-2 text-sm cursor-pointer",
                    )}
                  >
                    {menuItems.name}
                  </button>
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
}
